import React, { Component } from 'react';
import AppNavMenu from './AppNavMenu';
import styles from './AppLayoutStyles.module.scss'

export default class AppLayout extends Component {
    static displayName = AppLayout.name;

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={styles.mainLayout}>
                <AppNavMenu />
                <main tag="main" className={styles.layout}>
                    {this.props.children}
                </main>
            </div>
        );
    }
}
